import styled from 'styled-components'
import { CaptionSmall } from 'components/typography/caption'
import { Plain } from 'components/button'

export const Wrapper = styled(CaptionSmall)`
    margin-block: 8px 0;
`

export const SelectButton = styled(Plain)`
    display: inline-flex;
`